import options from './chart-co2.component';

export default {
    selector: 'dtChartCo2',
    options
};
